import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../Common/Icon';
import { daysToDaysWeeks } from '../../helpers/dateTime';

const TaskResultMobile = ({ task, showTask }) => {

    return (
        <div className="container" onClick={() => showTask(task.id)}>
            <div className="row">
                <div className="col-1">
                    {task.isMilestone ?
                        <span className="text-warning">&#x25C6;</span>
                        :
                    ""
                    }
                </div>
                <div className="col-3">
                    <Icon name="calendar-alt" /><span className="calendar ms-1">{daysToDaysWeeks(task.targetDaysOut)}</span>
                </div>
                <div className="col-8">
                    <span><Icon name="user" /> {task.contactName}</span>
                </div>
            </div>
            <div className="row mt-1">
                <div className="col-12">
                    <span className="description">{task.name}</span>
                </div>
            </div>
            <hr />
        </div>
    );
};

TaskResultMobile.propTypes = {
    task: PropTypes.object.isRequired,
    showTask: PropTypes.func.isRequired
};

export default TaskResultMobile;
